import { Component } from '@angular/core';

@Component({
  selector: 'mcrit-gestio-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Automotive Bridge';
  private menuVisible: boolean = false;

  public toggleMenu() {this.menuVisible=!this.menuVisible;return this.menuVisible;}
}
